/**
 * Подвал раздела «Планы»: сколько показано, свёртка групп, итог последней
 * записи в CRM. Вынесено из `pages/PlansPage.tsx` (нарезка 14.10.26).
 */

import type { Dispatch, SetStateAction } from "react";
import { nf } from "@/lib/format";
import type { PlanRow, PlanTotals } from "@/lib/providers";
import type { QrNote } from "./types";

export function PlansFooter({
  rows,
  totals,
  setFoldAll,
  setUnfoldAll,
  qrNote,
}: {
  rows: PlanRow[];
  totals: PlanTotals | undefined;
  setFoldAll: Dispatch<SetStateAction<number>>;
  setUnfoldAll: Dispatch<SetStateAction<number>>;
  qrNote: QrNote | null;
}) {
  return (
    <>
      {/* Перенос вместо сжатия на телефоне — иначе «показаны 178 из 178
          партий-дат» встаёт столбиком в одно слово шириной. */}
      <div className="flex min-h-[46px] flex-none items-center gap-3 rounded-b-[var(--radius-card)] border border-t-0 border-border bg-bg-subtle px-3 py-1.5 text-[12.5px] text-fg-muted max-md:flex-wrap">
        <span>
          показаны <b className="tnum text-fg">{nf.format(rows.length)}</b> из{" "}
          <b className="tnum text-fg">{totals ? nf.format(totals.plan_count) : "—"}</b>{" "}
          партий-дат
        </span>
        <span className="text-fg-faint">· виртуальный скролл, страниц нет</span>
        {/* Кнопки правят ТОЛЬКО группы: раскрытая партия живёт своим
            треугольником, и склеивать два действия в одно значит отнимать
            второе. В тулбар они не идут — он на 1920 px уже полон, и лишняя
            кнопка перенесла бы его на вторую строку, сдвинув таблицу вниз. */}
        <span data-annot="свёртка групп" className="flex flex-none items-center gap-2">
          <button
            type="button"
            onClick={() => setFoldAll((n) => n + 1)}
            title="свернуть все группы — останутся одни заголовки"
            className="text-fg-muted hover:text-fg"
          >
            свернуть все
          </button>
          <button
            type="button"
            onClick={() => setUnfoldAll((n) => n + 1)}
            title="развернуть все группы"
            className="text-fg-muted hover:text-fg"
          >
            развернуть все
          </button>
        </span>
        {qrNote ? (
          // Итог нажатия «в QR-папку» или смены даты — в подвале: строка
          // выбора наверху занята действиями, а ошибка должна дожить до
          // следующего нажатия, даже если отмеченное не снято.
          <span
            data-annot="итог QR-папки"
            title={qrNote.text}
            className={"ml-auto min-w-0 truncate " + (qrNote.error ? "text-err" : "text-ok")}
          >
            {qrNote.text}
            {qrNote.link ? (
              <>
                {" · "}
                <a
                  href={qrNote.link}
                  target="_blank"
                  rel="noreferrer"
                  className="underline"
                >
                  открыть в CRM
                </a>
              </>
            ) : null}
          </span>
        ) : (
          <span className="ml-auto text-fg-faint">данные CRM</span>
        )}
      </div>
    </>
  );
}
